import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CommonSelect from "../../../core/common/commonSelect";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";

const PrivacyPolicy = () => {
  const route = all_routes;

  const [selectedPdf, setSelectedPdf] = useState<string | null>(null);
  const [activeTab, setActiveTab] = useState("All Sops");

  const [sopsData, setSopsData] = useState([
    {
      title: "Anti Bribery Policy",
      status: "Acceptance Pending",
      pdfUrl:
        "https://team1consulting.com/weconnect/uploads/sops/Skip%20Manager%20Reviews.pdf#toolbar=0",
      accepted: false,
    },
    {
      title: "Code of Conduct",
      status: "Acceptance Pending",
      pdfUrl:
        "https://team1consulting.com/weconnect/uploads/sops/Coffee%20with%20the%20Manager.pdf#toolbar=0",
      accepted: false,
    },
    {
      title: "Performance Improvement Plan",
      status: "Acceptance Pending",
      pdfUrl:
        "https://team1consulting.com/weconnect/uploads/sops/Buddy%20System.pdf#toolbar=0",
      accepted: false,
    },
    {
      title: "Performance Improvement Plan Policy",
      status: "Acceptance Pending",
      pdfUrl:
        "https://team1consulting.com/weconnect/uploads/sops/Deal%20Registration%20Process.pdf#toolbar=0",
      accepted: false,
    },
    {
      title: "Bid Process",
      status: "Acceptance Pending",
      pdfUrl:
        "https://team1consulting.com/weconnect/uploads/sops/Special%20Bid%20Process.pdf#toolbar=0",
      accepted: false,
    },
    {
      title: "Notice Period Policy",
      status: "Finance & Accounts",
      pdfUrl:
        "https://team1consulting.com/weconnect/uploads/sops/Accounts%20Payable%20Vendor%20-%20SOP.pdf#toolbar=0",
      accepted: false,
    },
    {
      title: "Business Code of Conduct Policy",
      status: "Acceptance Pending",
      pdfUrl:
        "https://team1consulting.com/weconnect/uploads/sops/IT%20SOP.pdf#toolbar=0",
      accepted: false,
    },
    {
      title: "Working Beyond Office Hours or on Holiday",
      status: "Acceptance Pending",
      pdfUrl:
        "https://team1consulting.com/weconnect/uploads/sops/Onboarding-SOP.pdf#toolbar=0",
      accepted: false,
    },
    {
      title: "IT Asset Acceptance Policy",
      status: "Acceptance Pending",
      pdfUrl:
        "https://team1consulting.com/weconnect/uploads/sops/Recruitment-SOP.pdf#toolbar=0",
      accepted: false,
    },
  ]);

  const openModal = (pdfUrl: string) => {
    setSelectedPdf(pdfUrl);
  };

  const tabs = [
    { id: "All Sops", label: "All Policies" },
    { id: "HR", label: "HR Policies" },
    { id: "IT", label: "Travel Policies" },
    { id: "Finance & Accounts", label: "IT Policies" },
    { id: "Bid Support", label: "Employee Benefit Policies" },
  ];

  // Filter SOPs based on the active tab
  const filteredSops =
    activeTab === "All Sops"
      ? sopsData
      : sopsData.filter((sop) => sop.status === activeTab);

  const handleAccept = (index: number) => {
    setSopsData((prevData) => {
      const updatedData = [...prevData];
      updatedData[index] = {
        ...updatedData[index],
        status: "Policy has been accepted",
        accepted: true,
      };
      return updatedData;
    });
  };
  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Policies</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="#">
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Dashboard</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Policies
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}

          {/* Tabs */}
          <div className="card">
            <div className="card-body p-3">
              <div className="d-flex align-items-center justify-content-center">
                <ul className="nav nav-tabs justify-content-center">
                  {tabs.map((tab) => (
                    <li className="nav-item" key={tab.id}>
                      <button
                        className="nav-link px-4 py-2 rounded"
                        onClick={() => setActiveTab(tab.id)}
                        style={{
                          backgroundColor:
                            activeTab === tab.id ? "#F89520" : "transparent",
                          color: activeTab === tab.id ? "white" : "black",
                          border: "1px solid",
                          borderColor:
                            activeTab === tab.id ? "#F89520" : "#ddd", // Add border color for inactive tabs
                        }}
                      >
                        {tab.label}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* /Tabs */}

          {/* SOP Cards */}
          <div className="card">
            <div className="card-body">
              <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                {filteredSops.length > 0 ? (
                  filteredSops.map((sop, index) => (
                    <div className="col" key={index}>
                      <div className="card">
                        <div className="card-header">
                          <div className="card-title">{sop.title}</div>
                          <p
                            className="card-text"
                            style={{
                              color: sop.accepted ? "green" : "red",
                              fontWeight: "bold",
                            }}
                          >
                            Status: {sop.status}
                          </p>
                        </div>
                        <div className="card-body d-flex justify-content-between">
                          {sop.pdfUrl && (
                            <button
                              className="btn btn-primary"
                              onClick={() => openModal(sop.pdfUrl)}
                            >
                              View
                            </button>
                          )}
                          {!sop.accepted && (
                            <button
                              className="btn"
                              style={{
                                backgroundColor: "#F89520",
                                color: "white",
                              }}
                              onClick={() => handleAccept(index)}
                            >
                              Accept
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="text-center">
                    No SOPs found for this category.
                  </p>
                )}
              </div>
            </div>
          </div>
          {/* /SOP Cards */}
        </div>

        {/* PDF Modal */}
        {selectedPdf && (
          <div
            className="modal fade show d-block"
            tabIndex={-1}
            role="dialog"
            style={{ backgroundColor: "#7b7b7b" }}
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setSelectedPdf(null)}
                  ></button>
                </div>
                <div className="modal-body">
                  <iframe
                    src={selectedPdf}
                    width="100%"
                    height="500px"
                    style={{ border: "none" }}
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* /PDF Modal */}

        {/* Footer */}
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">© 2026 Aupertz. All rights reserved.</p>
          <p>
            Designed & Developed By{" "}
            <Link to="#" className="text-primary">
              Bizclockarts
            </Link>
          </p>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
